import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { State } from 'src/app/models/state.model';
import { StateService } from 'src/app/services';
import { LanguageService } from 'src/app/services/language.service';
import { ErrorMessageService } from 'src/app/shared/services';
import { LoginDto } from '../../models/login.model';
import { AuthService } from '../../services/auth.service';
import { IResultModel } from 'src/app/models/general/result.model';
import { LoginResult } from 'src/app/models/other/login-result.model';
import { SupportedLanguage } from 'src/app/models/supported-language.model';
import { AppState } from 'src/app/store/app.state';
@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public loginForm: UntypedFormGroup;
    public passwordForm: UntypedFormGroup;

    public state: State;
    public selectedLang: string;
    public currentMode: 'login' | 'forgottenPassword'= 'login';
    public supportedLanguages: SupportedLanguage[];

    @ViewChild('tabs') tabGroup: MatTabGroup;

    constructor(
        private authService: AuthService,
        stateService: StateService,
        private router: Router,
        private fb: UntypedFormBuilder,
        private msgService: ErrorMessageService,
        private languageService: LanguageService,
        private appState: AppState
    ) {
        this.state = stateService.state;
    }
    
    ngOnInit() {
        this.supportedLanguages = this.languageService.getSupportedLanguages();
        this.loginForm = this.createLoginForm();
        this.passwordForm = this.createPasswordForm();

        
        // Language initialization
        this.selectedLang = this.languageService.getCurrentLanguage();
        this.loginForm.get('lang').setValue(this.selectedLang);
        this.languageService.initializeLanguage();
    }

    createLoginForm(): UntypedFormGroup{
        return this.fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]],
            lang: ['']
        });        
    }

    createPasswordForm(): UntypedFormGroup{
        return this.fb.group({
            username: ['', [Validators.required]],
        });        
    }

    public ok() {
        if (this.currentMode === 'login')
        {
            if (this.loginForm.invalid)
                return;

            let formData = { ...this.loginForm.value, grant_type: 'password' } as LoginDto;
            formData.username = formData.username.toLowerCase();
                    
            this.authService.logIn(formData).subscribe({next: async () => {
                this.appState.iframeLoginMode.value = false;
                if (!localStorage.getItem('lang')) {
                    await this.languageService.setLanguage(this.selectedLang);
                }

                if (this.state.isAdmin || this.state.isAssistant || this.state.isSuperAdmin)
                    this.router.navigate(['/settings']);
                else
                    this.router.navigate(['/']);
            }, error: (err: IResultModel<LoginResult>) => {
                this.msgService.handleError<LoginResult>(err);
            }});
        }
        else if (this.currentMode === 'forgottenPassword') {
            if (this.passwordForm.invalid)
                return;
            let username = (this.passwordForm.value.username as string).toLowerCase();
            
            this.authService.forgottenPassword(username)
                .subscribe({ next: () => { 
                    this.msgService.showSnackBarMessage('passwordReminderSent', 8000);
                    this.switchMode();
                }, error: () => {
                    this.msgService.showSnackBarMessage('forgottenPasswordError', 8000);
                }});
            
        }
    };

    public switchMode() {
        if (this.currentMode === 'login')
        {
            this.currentMode = 'forgottenPassword';
            this.tabGroup.selectedIndex = 1;
        }
        else if (this.currentMode === 'forgottenPassword')
        {
            this.currentMode = 'login';
            this.tabGroup.selectedIndex = 0;
        }
    }

  public async onLanguageChange(lang: string) {
    this.selectedLang = lang;
    await this.languageService.setLanguage(lang);
  }

}
